module.exports = __webpack_public_path__ + "e03a9f40a3eff075ac1ed1cd24397a7d.svg";